import { useGetMapDataQuery } from "../../../../../app/rmfApi";

export const useMapData = (mapDataMeta: any) => {
  const { data } = useGetMapDataQuery(mapDataMeta?.data?.id);
  return data;
};
